import React from 'react';

import { Link } from 'react-router-dom';

const BoothList = ({match}) => {
  const booth = ['1', '2', '3'];    // TODO: db
  const boothList = booth.map(
      (num) => {
        const booth_id = '/'+num
        const id = Number(num);
        return <li key={id}><Link to={booth_id}> {num}번 페이지 </Link></li>
      });
  return(
    <div className="boothList">
      <div>
          <ul>
            {boothList}
          </ul>
      </div>
    </div>
  );
}


// class BoothList extends Component {
//   render(){
//     const booth = ['1', '2', '3'];    // TODO: db
//     const boothList = booth.map(
//       (num) => {
//         const booth_id = "/booth/"+num;
//         const id = Number(num);
//         return <li key={id}><Link to={booth_id}> {num}번 페이지 </Link></li>
//     });
    
//     return(
//       <div>
//         <div>
//             <ul>
//               {boothList}
//             </ul>
//         </div>

//         <BrowserRouter>
//           <Route path="/booth/:boothId" component={Content} />
//         </BrowserRouter>
//       </div>
//     );
//   }
// }
export default BoothList;